import { Component } from "@angular/core";
import { HeroComponent } from "../../components/hero/hero.component";
import { BookingFormComponent } from "../../components/booking-form/booking-form.component";
import { OurRoomsSectionComponent } from "../../components/our-rooms-section/our-rooms-section.component";
import { LocationComponent } from "../../components/location/location.component";
import { Title } from "@angular/platform-browser";
import { SITE_CONSTANTS } from "@estatex/types";
@Component({
    selector: "app-main",
    standalone: true,
    imports: [HeroComponent, BookingFormComponent, OurRoomsSectionComponent, LocationComponent],
    templateUrl: "./main.component.html",
    styleUrl: "./main.component.css",
})
export class MainComponent {
    constructor(private readonly titleService: Title) {
        this.titleService.setTitle(SITE_CONSTANTS.HOMEPAGE);
    }
}
